import { Box, styled } from "@mui/material";
import React from "react";
import { TableType } from "../serverSide/types";
import BaseSkeleton from "./BaseSkeleton";

interface LoadingOverlayProps {
  tableType: TableType;
}

const StyledOverlayBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "tableType",
})<{ tableType: TableType }>(({ theme, tableType }) => ({
  position: tableType === "subDataList" ? "absolute" : "relative",
  top: tableType === "subDataList" ? "-70px" : 0,
  left: 0,
  right: 0,
  backgroundColor: "transparent",
  zIndex: 1301,
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  paddingTop: tableType === "subDataList" ? "calc(16px + 8px)" : theme.spacing(2),
  width: "100%",
}));

export const LoadingOverlay = ({ tableType }: LoadingOverlayProps) => {
  const skeletonWidths =
    tableType === "subDataList" ? ["60%", "80%", "70%", "75%", "65%", "50%"] : Array(2).fill("100%");

  return (
    <StyledOverlayBox tableType={tableType} className="MuiDataGrid-overlayLoadingVariant">
      <BaseSkeleton />
      {skeletonWidths.map((width, index) => (
        <BaseSkeleton key={index} width={width} />
      ))}
    </StyledOverlayBox>
  );
};

export default LoadingOverlay;
